package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.px


val DesktopNavDiv = CssStyle {
    Breakpoint.LG {

            Modifier
                .display(DisplayStyle.Flex)
                .gap(2.px)
                .alignItems(AlignItems.Center)
        }
    (
            Breakpoint.ZERO until Breakpoint.LG){
        Modifier.display(DisplayStyle.None)
    }


}